/* eslint-disable @typescript-eslint/no-magic-numbers */
import { Serialisers } from './serialisers';
export const interleave = (source, obj) => source
    .flat()
    .flatMap((value, index, array) => (array.length - 1 !== index ? [value, obj] : value));
export const ensureArray = (value) => (Array.isArray(value) ? value : [value]);
export const isExpressionParams = (value) => ((Array.isArray(value) && value.length === 3) ||
    (value.length === 4 && Array.isArray(value[0])) ||
    typeof value[0] === 'string') &&
    typeof value[1] === 'function' &&
    Object.values(Serialisers).includes(value[1]);
